// extracted by mini-css-extract-plugin
export default {"DiscardButton":"_DiscardButton--6T1PY","TooltipMessage":"_TooltipMessage--dVWAn","TooltipTrigger":"_TooltipTrigger--Mqtgv"};